import { setSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

type CategoryLicensePayload = {
  enabled: boolean;
  dealer_location_id: number;
};

export const useCategoryLicensesMutation = () =>
  useTypedMutation<CategoryLicensePayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/licenses/category/toggle", payload, ENV.exactBaseURL)).data,
    onSuccess: ({ enabled }) => {
      const selectedLocation = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedLocation);
      if (selectedLocation) setSelectedLocation({ ...selectedLocation, exact_is_category_licence_enabled: enabled });

      // TODO: In most cases, we don't need to invalidate cache when we have the data to update the current cache - make a ticket for all the places where this is appliable and update the logic to not use invalidate
      typedQueryClient.invalidateQueries(LocationLicenseOverviewKeys.licenses);
    }
  });
